export default {"src":"/_next/static/media/stars.da4f3219.svg","height":396,"width":952,"blurWidth":0,"blurHeight":0};